import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => {
    const textStyle = {
        fontWeight: '500',
        fontFamily: theme.fontFamily
    }

    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 70px)',
            gap: 32
        },
        deviceSectionContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',

            [theme.breakpoints.down(980)]: {
                flexWrap: 'wrap-reverse',
                marginTop: 50
            }
        },

        // DEVICE IMAGES
        deviceImagesWrapper: {
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            height: 130,
            width: 120,
            marginRight: 20
        },

        reportStatusWrapper: {
            position: 'absolute',
            right: '2px',
            bottom: '2px',
            backgroundColor: theme.background,
            borderRadius: '50%'
        },

        // NAME AND BATTERY
        deviceNameAndBatteryWrapper: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 20,
            width: 'calc(100% - 130px)'
        },
        deviceNameWrapper: {
            display: 'flex',
            gap: 5,
            alignItems: 'center'
        },
        deviceName: {
            color: theme.textPrimary,
            fontSize: 24,
            ...textStyle
        },
        deviceLocation: {
            color: theme.textSecondary,
            fontSize: 16,
            ...textStyle
        },
        batteryStatusWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: 5
        },
        sectionsWrapper: {
            display: 'flex',
            flexDirection: 'row'
        },
        detailsWrapper: {
            flex: 1
        },
        input: {
            marginBottom: 16
        },
        section: {
            marginTop: 16
        },
        select: {
            marginBottom: 16
        },

        // DEVICE BASIC INFO AND TABLE
        tableTh: {
            paddingRight: 30,
            paddingBottom: 10,
            maxWidth: 170,
            verticalAlign: 'top',
            textAlign: 'left'
        },
        tableTd: {
            paddingBottom: 10,
            verticalAlign: 'top',
            maxWidth: 200
        },

        rightCellText: {
            color: theme.textPrimary,
            fontWeight: 500,
            fontSize: 15,
            overflowWrap: 'break-word'
        },
        leftCellText: {
            color: theme.textSecondary,
            fontWeight: 500,
            fontSize: 15,
            overflowWrap: 'break-word'
        },

        link: {
            cursor: 'pointer',
            textDecoration: 'none',
            color: theme.primary,
            fontWeight: 'bold'
        },

        // ADVANCED INFORMATION
        advancedInformationContainer: {
            position: 'relative',
            width: '60vw',
            [theme.breakpoints.down(980)]: {
                width: '100%'
            }
        },
        advancedInformationHeadingWrapper: {
            display: 'flex',
            gap: 10,
            padding: '10px 0',
            cursor: 'pointer'
        },

        // DEVICE REPORTS
        deviceReportsLink: {
            paddingBottom: 10
        },
        deviceReportsCard: { borderRadius: theme.borderRadius10 },
        deviceReportsCardContent: {
            display: 'flex',
            gap: 10,
            justifyContent: 'space-between',
            outline: '0.5px solid light-grey'
        },
        advancedInformationCardContent: {
            display: 'flex',
            gap: 10,
            outline: '0.5px solid light-grey',
            maxHeight: '61px',
            alignItems: 'center'
        },
        networkDeviceStatusCard: {
            borderRadius: theme.borderRadius10,
            width: '200px'
        },
        searchClearIcon: {
            padding: 0,
            position: 'absolute',
            right: 8
        },
        // BAIT AND ACTIVITY CARDS
        deviceInfoCard: {
            borderRadius: theme.borderRadius10,
            width: 400,
            height: 240,
            boxShadow: theme.boxShadow
        },
        deviceInfoCardContent: {
            padding: '24px !important',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        deviceInfoCardHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 16
        },
        cardTitle: {
            fontSize: 16,
            fontWeight: 600,
            color: theme.textPrimary
        },

        // BAIT CARD SPECIFIC
        baitStatusWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        },
        baitStatusIndicator: {
            width: 8,
            height: 8,
            borderRadius: '50%'
        },
        baitStatusText: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.textPrimary
        },
        baitAmountWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            marginBottom: 16
        },
        baitAmountSymbol: {
            fontSize: 48,
            fontWeight: 400,
            color: theme.textPrimary
        },
        baitAmountValue: {
            fontSize: 48,
            fontWeight: 600,
            color: theme.textPrimary
        },
        baitLastReplacement: {
            fontSize: 14,
            color: theme.textSecondary
        },

        // BAIT DEBOUNCE NOTICE
        baitDebounceNotice: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 10,
            // Aligns the notice to the bait card row it explains (400 + 24 + 400)
            maxWidth: 824,
            padding: '12px 14px',
            borderRadius: theme.borderRadius,
            backgroundColor: theme.blueLight
        },
        baitDebounceNoticeIcon: {
            color: theme.blue,
            flexShrink: 0,
            marginTop: 2
        },
        baitDebounceNoticeText: {
            fontSize: 14,
            lineHeight: 1.6,
            color: theme.gray,
            fontFamily: theme.fontFamily
        },
        baitDebounceNoticeDuration: {
            fontWeight: 600,
            fontVariantNumeric: 'tabular-nums',
            color: theme.blue
        },
        baitDebounceNoticeStrong: {
            fontWeight: 600,
            color: theme.gray
        },
        baitDebounceNoticeAction: {
            padding: 0,
            border: 'none',
            background: 'none',
            font: 'inherit',
            fontWeight: 600,
            color: theme.blue,
            cursor: 'pointer',
            textDecoration: 'underline',
            textUnderlineOffset: 2,
            transition: 'opacity 140ms ease',
            '&:hover': {
                opacity: 0.7
            },
            '&:focus-visible': {
                outline: `2px solid ${theme.blue}`,
                outlineOffset: 2,
                borderRadius: 2
            }
        },

        // ACTIVITY CARD SPECIFIC
        activityIconWrapper: {
            display: 'flex',
            justifyContent: 'flex-start'
        },
        activityCountWrapper: {
            display: 'flex',
            alignItems: 'baseline',
            flexDirection: 'column',
            gap: 8
        },
        activityCount: {
            fontSize: 48,
            fontWeight: 600,
            color: theme.textPrimary
        },
        activityPeriod: {
            fontSize: 14,
            color: theme.textSecondary
        },
        activityResetWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        activityResetLabel: {
            fontSize: 14,
            color: theme.textSecondary
        },

        // GATEWAY CARD
        gatewayCardLink: {
            display: 'block',
            width: 'fit-content',
            textDecoration: 'none',
            borderRadius: theme.borderRadius10,
            '&:focus-visible': {
                outline: `2px solid ${theme.primary}`,
                outlineOffset: 2
            }
        },
        gatewayCard: {
            borderRadius: theme.borderRadius10,
            width: 400
        },
        gatewayCardInteractive: {
            transition: 'box-shadow 140ms ease, transform 140ms ease',
            '&:hover': {
                transform: 'translateY(-1px)',
                boxShadow: '0 6px 16px rgba(60, 60, 60, 0.14)'
            },
            '&:hover $gatewayChevron': {
                transform: 'translateX(2px)'
            },
            '@media (prefers-reduced-motion: reduce)': {
                transition: 'none',
                '&:hover': { transform: 'none' },
                '&:hover $gatewayChevron': { transform: 'none' }
            }
        },
        gatewayCardContent: {
            padding: '20px !important',
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        },
        gatewayIdentity: {
            display: 'flex',
            alignItems: 'center',
            gap: 14
        },
        gatewayIconPlate: {
            width: 44,
            height: 44,
            flexShrink: 0,
            borderRadius: theme.borderRadius,
            backgroundColor: theme.tertiary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        gatewayIconPlateSkeleton: {
            flexShrink: 0,
            borderRadius: theme.borderRadius
        },
        // Lets the serial ellipsize instead of pushing the chevron out of the card
        gatewayIdentityText: {
            flex: 1,
            minWidth: 0
        },
        gatewaySerial: {
            fontSize: 18,
            fontWeight: 600,
            color: theme.textPrimary,
            fontVariantNumeric: 'tabular-nums'
        },
        gatewaySubline: {
            fontSize: 14,
            color: theme.textSecondary
        },
        gatewayChevron: {
            flexShrink: 0,
            transition: 'transform 140ms ease'
        },
        gatewayFooter: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 10,
            paddingTop: 14,
            borderTop: `1px solid ${theme.grayLight}`
        },
        gatewayStatus: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        },
        gatewayStatusDot: {
            width: 8,
            height: 8,
            flexShrink: 0,
            borderRadius: '50%'
        },
        gatewayStatusText: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.textPrimary
        },
        gatewayLastSignal: {
            fontSize: 13,
            color: theme.textSecondary,
            fontVariantNumeric: 'tabular-nums'
        },

        // ACTIVITY CHART
        activityChartCard: {
            borderRadius: theme.borderRadius10,
            width: '100%',
            boxShadow: theme.boxShadow
        },
        activityChartHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 20
        },
        activityChartTitle: {
            fontSize: 18,
            fontWeight: 600,
            color: theme.textPrimary
        },
        activityChartSubtitle: {
            fontSize: 14,
            color: theme.textSecondary,
            marginTop: 4
        },
        activityChartWrapper: {
            width: '100%',
            height: 200
        },
        chartTooltip: {
            backgroundColor: theme.background,
            border: `1px solid ${theme.grayLight}`,
            borderRadius: theme.borderRadius,
            padding: 10
        }
    }
})
